import ButtonIcon from "@mui/icons-material/Add"
import { Button } from "@mui/material"
import React from "react"
import { ButtonProps, Link, useRecordContext } from "react-admin"

export const AddMembershipButton: React.FC<ButtonProps> = (props) => {
  const record = useRecordContext(props)

  return (
    <Button
      title="Add Member"
      color="primary"
      component={Link}
      to={{
        pathname: "/customer_memberships/create",
      }}
      state={{ record: { customer_id: record.id } }}
    >
      <ButtonIcon /> Add Member
    </Button>
  )
}
